/** Shared frame styling for Today day-progress dot grids. */
import { STATIC_CARD_BORDER_SX } from '@/components/ui/staticCardBorderSx';

export const DAY_PROGRESS_DOTS_FRAME_SX = {
  ...STATIC_CARD_BORDER_SX,
  width: '100%',
  p: 1,
  bgcolor: 'background.paper',
};
